import { type ReactNode } from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { siteConfig } from "@/data/site";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

interface LayoutProps {
  children: ReactNode;
  className?: string;
}

export default function Layout({ children, className }: LayoutProps) {
  const whatsappUrl = `https://wa.me/91${siteConfig.contact.whatsapp}`;
  const emergencyUrl = `tel:${siteConfig.contact.emergency.replace(/-/g, "")}`;

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />

      <main className={cn("flex-1", className)}>{children}</main>

      <Footer />

      {/* WhatsApp floating button */}
      <motion.a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 260, damping: 20 }}
        className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-lg shadow-green-500/30 transition-transform hover:scale-110 active:scale-95"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-6 w-6" />
      </motion.a>

      {/* Emergency floating button (mobile only) */}
      <motion.a
        href={emergencyUrl}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 20 }}
        className="fixed bottom-6 left-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-red-600 text-white shadow-lg shadow-red-600/30 transition-transform hover:scale-110 active:scale-95 md:hidden"
        aria-label="Call Emergency"
      >
        <Phone className="h-6 w-6" />
      </motion.a>
    </div>
  );
}
